import { useState, useEffect } from 'react';

const API_URL = 'https://www.tagy-wheels.de/backend/api.php';

function LagerSystem() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [activeTab, setActiveTab] = useState('einlagerung');
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [formData, setFormData] = useState({
    vorname: '',
    nachname: '',
    reifengroesse: '',
    komplettraeder: 'Ja',
    marke: '',
    lagerort: '',
    dot: '',
    stueckzahl: 1,
    profiltiefe: '',
    notizen: ''
  });

  const styles = {
    body: {
      margin: 0,
      padding: 0,
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      background: '#0a0a0a',
      color: '#e5e5e5',
      minHeight: '100vh',
      paddingTop: '80px'
    },
    logo: {
      position: 'absolute',
      top: '1rem',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 1000,
      width: '80px',
      height: 'auto',
      opacity: 0.6
    },
    container: {
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '1rem'
    },
    loginBox: {
      maxWidth: '420px',
      margin: '50px auto',
      background: '#1a1a1a',
      padding: '2rem',
      borderRadius: '12px',
      border: '1px solid #2a2a2a'
    },
    loginTitle: {
      fontSize: '1.5rem',
      fontWeight: '600',
      marginBottom: '2rem',
      color: '#fff',
      textAlign: 'center'
    },
    inputGroup: {
      marginBottom: '1.25rem'
    },
    label: {
      display: 'block',
      fontSize: '0.875rem',
      fontWeight: '500',
      marginBottom: '0.5rem',
      color: '#a0a0a0'
    },
    input: {
      width: '100%',
      padding: '0.75rem',
      background: '#0a0a0a',
      border: '1px solid #2a2a2a',
      borderRadius: '6px',
      color: '#e5e5e5',
      fontSize: '1rem',
      outline: 'none',
      boxSizing: 'border-box'
    },
    button: {
      width: '100%',
      padding: '0.875rem',
      background: '#3b82f6',
      border: 'none',
      borderRadius: '6px',
      color: '#fff',
      fontSize: '1rem',
      fontWeight: '500',
      cursor: 'pointer',
      touchAction: 'manipulation'
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '1.5rem',
      paddingBottom: '1rem',
      borderBottom: '1px solid #2a2a2a',
      flexWrap: 'wrap',
      gap: '1rem'
    },
    title: {
      fontSize: '1.5rem',
      fontWeight: '600',
      color: '#fff',
      margin: 0
    },
    logoutBtn: {
      padding: '0.5rem 1rem',
      background: '#1a1a1a',
      border: '1px solid #2a2a2a',
      borderRadius: '6px',
      color: '#e5e5e5',
      fontSize: '0.875rem',
      cursor: 'pointer',
      touchAction: 'manipulation'
    },
    tabs: {
      display: 'flex',
      gap: '0.5rem',
      marginBottom: '1.5rem',
      borderBottom: '1px solid #2a2a2a',
      paddingBottom: '0',
      overflowX: 'auto'
    },
    tab: {
      padding: '0.75rem 1.25rem',
      background: 'transparent',
      border: 'none',
      borderBottom: '2px solid transparent',
      color: '#a0a0a0',
      fontSize: '0.9rem',
      fontWeight: '500',
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      touchAction: 'manipulation'
    },
    tabActive: {
      color: '#3b82f6',
      borderBottomColor: '#3b82f6'
    },
    searchBar: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.75rem',
      marginBottom: '1.5rem'
    },
    searchInput: {
      width: '100%',
      padding: '0.75rem 1rem',
      background: '#1a1a1a',
      border: '1px solid #2a2a2a',
      borderRadius: '6px',
      color: '#e5e5e5',
      fontSize: '1rem',
      outline: 'none',
      boxSizing: 'border-box'
    },
    searchButtons: {
      display: 'flex',
      gap: '0.75rem'
    },
    btnSecondary: {
      flex: 1,
      padding: '0.75rem 1rem',
      background: '#1a1a1a',
      border: '1px solid #2a2a2a',
      borderRadius: '6px',
      color: '#e5e5e5',
      fontSize: '0.875rem',
      fontWeight: '500',
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      touchAction: 'manipulation'
    },
    btnPrimary: {
      flex: 1,
      padding: '0.75rem 1rem',
      background: '#3b82f6',
      border: 'none',
      borderRadius: '6px',
      color: '#fff',
      fontSize: '0.875rem',
      fontWeight: '500',
      cursor: 'pointer',
      touchAction: 'manipulation'
    },
    formCard: {
      background: '#1a1a1a',
      padding: '1.5rem',
      marginBottom: '1.5rem',
      borderRadius: '12px',
      border: '1px solid #2a2a2a'
    },
    formGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: '1.25rem',
      marginBottom: '1.5rem'
    },
    formButtons: {
      display: 'flex',
      gap: '0.75rem',
      flexDirection: 'column'
    },
    tableWrapper: {
      overflowX: 'auto',
      WebkitOverflowScrolling: 'touch'
    },
    table: {
      width: '100%',
      background: '#1a1a1a',
      borderRadius: '12px',
      overflow: 'hidden',
      border: '1px solid #2a2a2a',
      minWidth: '600px'
    },
    thead: {
      background: '#0a0a0a'
    },
    th: {
      padding: '0.875rem',
      textAlign: 'left',
      fontSize: '0.75rem',
      fontWeight: '600',
      color: '#a0a0a0',
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    },
    td: {
      padding: '0.875rem',
      borderTop: '1px solid #2a2a2a',
      fontSize: '0.875rem',
      color: '#e5e5e5'
    },
    actionBtn: {
      padding: '0.5rem 0.875rem',
      background: 'transparent',
      border: '1px solid #2a2a2a',
      borderRadius: '4px',
      color: '#e5e5e5',
      fontSize: '0.75rem',
      cursor: 'pointer',
      marginRight: '0.5rem',
      marginBottom: '0.5rem',
      touchAction: 'manipulation',
      whiteSpace: 'nowrap'
    },
    deleteBtn: {
      background: '#ef4444',
      borderColor: '#ef4444',
      color: '#fff'
    },
    emptyState: {
      textAlign: 'center',
      padding: '3rem 1rem',
      color: '#6b7280',
      fontSize: '0.95rem'
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      loadData();
    }
  }, [activeTab, isLoggedIn]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_URL}?action=login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      const result = await response.json();
      if (result.success) {
        setIsLoggedIn(true);
      } else {
        alert('Falsche Anmeldedaten');
      }
    } catch (error) {
      alert('Login fehlgeschlagen');
    }
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUsername('');
    setPassword('');
  };

  const loadData = async () => {
    try {
      const url = searchTerm 
        ? `${API_URL}?table=${activeTab}&search=${encodeURIComponent(searchTerm)}`
        : `${API_URL}?table=${activeTab}`;
      
      const response = await fetch(url);
      const result = await response.json();
      setData(result);
    } catch (error) {
      alert('Fehler beim Laden');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const url = editItem 
      ? `${API_URL}?table=${activeTab}&id=${editItem.id}`
      : `${API_URL}?table=${activeTab}`;
    
    const method = editItem ? 'PUT' : 'POST';
    
    try {
      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      
      const result = await response.json();
      if (result.success || result.id) {
        await loadData();
        resetForm();
      }
    } catch (error) {
      alert('Fehler: ' + error.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Wirklich löschen?')) return;
    
    try {
      await fetch(`${API_URL}?table=${activeTab}&id=${id}`, {
        method: 'DELETE'
      });
      await loadData();
    } catch (error) {
      alert('Fehler beim Löschen');
    }
  };

  const handleEdit = (item) => {
    setEditItem(item);
    setFormData(item);
    setShowForm(true);
  };

  const resetForm = () => {
    setFormData({
      vorname: '',
      nachname: '',
      reifengroesse: '',
      komplettraeder: 'Ja',
      marke: '',
      lagerort: '',
      dot: '',
      stueckzahl: 1,
      profiltiefe: '',
      notizen: ''
    });
    setEditItem(null);
    setShowForm(false);
  };

  if (!isLoggedIn) {
    return (
      <div style={styles.body}>
        <img src="/Tagy_logo.png" alt="Tagy Wheels" style={styles.logo} />
        <div style={styles.loginBox}>
          <h2 style={styles.loginTitle}>Anmelden</h2>
          <form onSubmit={handleLogin}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Benutzername</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                style={styles.input}
                required
              />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Passwort</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={styles.input}
                required
              />
            </div>
            <button type="submit" style={styles.button}>
              Anmelden
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.body}>
      <img src="/Tagy_logo.png" alt="Tagy Wheels" style={styles.logo} />
      <div style={styles.container}>
        <div style={styles.header}>
          <h1 style={styles.title}>Reifenlager</h1>
          <button onClick={handleLogout} style={styles.logoutBtn}>
            Abmelden
          </button>
        </div>

        <div style={styles.tabs}>
          <button
            onClick={() => setActiveTab('einlagerung')}
            style={{
              ...styles.tab,
              ...(activeTab === 'einlagerung' ? styles.tabActive : {})
            }}
          >
            Kompletträder
          </button>
          <button
            onClick={() => setActiveTab('reifen')}
            style={{
              ...styles.tab,
              ...(activeTab === 'reifen' ? styles.tabActive : {})
            }}
          >
            Reifen
          </button>
        </div>

        <div style={styles.searchBar}>
          <input
            type="text"
            placeholder="Suchen..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={styles.searchInput}
          />
          <div style={styles.searchButtons}>
            <button onClick={loadData} style={styles.btnSecondary}>
              Suchen
            </button>
            <button onClick={() => setShowForm(!showForm)} style={styles.btnPrimary}>
              Neu anlegen
            </button>
          </div>
        </div>

        {showForm && (
          <div style={styles.formCard}>
            <h3 style={{ marginTop: 0, marginBottom: '1.5rem', color: '#fff' }}>
              {editItem ? 'Bearbeiten' : 'Neu anlegen'}
            </h3>
            <form onSubmit={handleSubmit}>
              <div style={styles.formGrid}>
                {/* Vorname & Nachname nur bei Einlagerung (Kompletträder) */}
                {activeTab === 'einlagerung' && (
                  <>
                    <div>
                      <label style={styles.label}>Vorname</label>
                      <input
                        type="text"
                        value={formData.vorname}
                        onChange={(e) => setFormData({...formData, vorname: e.target.value})}
                        placeholder="Max"
                        style={styles.input}
                        required
                      />
                    </div>
                    <div>
                      <label style={styles.label}>Nachname</label>
                      <input
                        type="text"
                        value={formData.nachname}
                        onChange={(e) => setFormData({...formData, nachname: e.target.value})}
                        placeholder="Mustermann"
                        style={styles.input}
                        required
                      />
                    </div>
                  </>
                )}
                
                <div>
                  <label style={styles.label}>Reifengröße</label>
                  <input
                    type="text"
                    value={formData.reifengroesse}
                    onChange={(e) => setFormData({...formData, reifengroesse: e.target.value})}
                    placeholder="205/55 R16"
                    style={styles.input}
                    required
                  />
                </div>

                {/* Kompletträder Ja/Nein nur bei Einlagerung */}
                {activeTab === 'einlagerung' && (
                  <div>
                    <label style={styles.label}>Kompletträder</label>
                    <select
                      value={formData.komplettraeder}
                      onChange={(e) => setFormData({...formData, komplettraeder: e.target.value})}
                      style={styles.input}
                      required
                    >
                      <option value="Ja">Ja</option>
                      <option value="Nein">Nein</option>
                    </select>
                  </div>
                )}

                {/* DOT nur bei Reifen */}
                {activeTab === 'reifen' && (
                  <div>
                    <label style={styles.label}>DOT</label>
                    <input
                      type="text"
                      value={formData.dot}
                      onChange={(e) => setFormData({...formData, dot: e.target.value})}
                      placeholder="2519"
                      style={styles.input}
                      required
                    />
                  </div>
                )}
                
                <div>
                  <label style={styles.label}>Marke</label>
                  <input
                    type="text"
                    value={formData.marke}
                    onChange={(e) => setFormData({...formData, marke: e.target.value})}
                    placeholder="Continental"
                    style={styles.input}
                    required
                  />
                </div>
                
                <div>
                  <label style={styles.label}>Lagerort</label>
                  <input
                    type="text"
                    value={formData.lagerort}
                    onChange={(e) => setFormData({...formData, lagerort: e.target.value})}
                    placeholder="Regal A3"
                    style={styles.input}
                    required
                  />
                </div>

                {/* Stückzahl nur bei Reifen */}
                {activeTab === 'reifen' && (
                  <div>
                    <label style={styles.label}>Stückzahl</label>
                    <input
                      type="number"
                      min="1"
                      value={formData.stueckzahl}
                      onChange={(e) => setFormData({...formData, stueckzahl: e.target.value})}
                      placeholder="4"
                      style={styles.input}
                      required
                    />
                  </div>
                )}

                {/* Profiltiefe nur bei Reifen */}
                {activeTab === 'reifen' && (
                  <div>
                    <label style={styles.label}>Profiltiefe (mm)</label>
                    <input
                      type="number"
                      step="0.1"
                      value={formData.profiltiefe}
                      onChange={(e) => setFormData({...formData, profiltiefe: e.target.value})}
                      placeholder="5.5"
                      style={styles.input}
                    />
                  </div>
                )}
                
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={styles.label}>Notizen</label>
                  <textarea
                    value={formData.notizen}
                    onChange={(e) => setFormData({...formData, notizen: e.target.value})}
                    style={{...styles.input, minHeight: '80px', resize: 'vertical'}}
                  />
                </div>
              </div>
              <div style={styles.formButtons}>
                <button type="submit" style={styles.btnPrimary}>
                  Speichern
                </button>
                <button type="button" onClick={resetForm} style={styles.btnSecondary}>
                  Abbrechen
                </button>
              </div>
            </form>
          </div>
        )}

        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead style={styles.thead}>
              <tr>
                {activeTab === 'einlagerung' && <th style={styles.th}>Vorname</th>}
                {activeTab === 'einlagerung' && <th style={styles.th}>Nachname</th>}
                <th style={styles.th}>Größe</th>
                {activeTab === 'einlagerung' && <th style={styles.th}>Kompletträder</th>}
                {activeTab === 'reifen' && <th style={styles.th}>DOT</th>}
                <th style={styles.th}>Marke</th>
                <th style={styles.th}>Lagerort</th>
                {activeTab === 'reifen' && <th style={styles.th}>Stück</th>}
                {activeTab === 'reifen' && <th style={styles.th}>Profil</th>}
                <th style={styles.th}>Notizen</th>
                <th style={styles.th}>Aktionen</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={item.id}>
                  {activeTab === 'einlagerung' && <td style={styles.td}>{item.vorname}</td>}
                  {activeTab === 'einlagerung' && <td style={styles.td}>{item.nachname}</td>}
                  <td style={styles.td}>{item.reifengroesse}</td>
                  {activeTab === 'einlagerung' && <td style={styles.td}>{item.komplettraeder}</td>}
                  {activeTab === 'reifen' && <td style={styles.td}>{item.dot}</td>}
                  <td style={styles.td}>{item.marke}</td>
                  <td style={styles.td}>{item.lagerort}</td>
                  {activeTab === 'reifen' && <td style={styles.td}>{item.stueckzahl}</td>}
                  {activeTab === 'reifen' && <td style={styles.td}>{item.profiltiefe} mm</td>}
                  <td style={styles.td}>{item.notizen}</td>
                  <td style={styles.td}>
                    <button 
                      onClick={() => handleEdit(item)} 
                      style={styles.actionBtn}
                    >
                      Bearbeiten
                    </button>
                    <button 
                      onClick={() => handleDelete(item.id)} 
                      style={{...styles.actionBtn, ...styles.deleteBtn}}
                    >
                      Löschen
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {data.length === 0 && (
          <div style={styles.emptyState}>
            Keine Einträge vorhanden
          </div>
        )}
      </div>
    </div>
  );
}

export default LagerSystem;